import React, { FunctionComponent } from 'react';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputAdornment from '@material-ui/core/InputAdornment';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';

import { currencyMapper } from '../../../utils/utils';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      borderRadius: '2px',
      marginRight: '8px',
      flex: 1,
      '& input': {
        padding: '11px 16px 11px 0px !important',
        fontSize: '0.875rem',
        border: 'none',
        maxWidth: '100%',
        cursor: 'text',
      },
      '& .MuiOutlinedInput-notchedOutline': {
        border: '1px solid #B0B0B03B',
      },
      '&:hover': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: '#B0B0B03B',
        },
      },
      '&.Mui-focused': {
        outline: 'none',
        '& .MuiOutlinedInput-notchedOutline': {
          borderWidth: '1px',
          borderColor: '#304ffe',
        },
        '&:hover': {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#304ffe',
          },
        },
      },
    },
  }),
);

const InputWithIcon: FunctionComponent<{
  handleChange?: any;
  register?: any;
  type?: string;
  placeholder?: string;
  currency?: string;
  name?: string;
}> = ({ handleChange, register, placeholder, name, type = 'text', currency = 'INR' }) => {
  const classes = useStyles();
  return (
    <OutlinedInput
      id="standard-adornment-amount"
      onChange={handleChange}
      startAdornment={<InputAdornment position="start">{currencyMapper[currency]}</InputAdornment>}
      labelWidth={0}
      className={classes.root}
      placeholder={placeholder}
      type={type}
      name={name}
      inputRef={register({ required: true })}
    />
  );
};

export default InputWithIcon;
